module.exports = __webpack_public_path__ + "static/media/close_icon.b9946b3b.svg";